<template>
  <div>
    <!-- Description block -->
    <div class="content-view-body">
      <div class="card-body" id="update_description" :class="{'pr-0 pl-0': showOnTask}">
        <div class="mb-2">
          <h5 class="h5" v-if="!showOnTask">
            <span class="float-right" v-if="showDescriptionInput">
              <div class="text-right">
                <b-button class="btn-sm inline-edit-button"
                          variant="secondary"
                          @click="cancelDescriptionForm"
                          qid="process-description-cancel-button"
                >
                  {{ $t('processes.legal_basis.create.cancel') }}
                </b-button>
                <b-button class="ml-3 mr-0 btn-sm inline-edit-button"
                          variant="success"
                          @click="formDescriptionSubmit"
                          qid="incident-description-submit-button"
                          v-if="isGranted([permissions.INCIDENT_CATEGORY_EDIT, permissions.INCIDENT_CATEGORY_EDIT_OWN], incident)"
                >
                  {{ $t('processes.legal_basis.create.submit') }}
                </b-button>
              </div>
            </span>
            <span class="float-right btn-sm btn-edit mr-0"
                  @click="showDescriptionInputFunction"
                  qid="edit-process-description"
                  v-if="!showDescriptionInput && isGranted([permissions.INCIDENT_CATEGORY_EDIT, permissions.INCIDENT_CATEGORY_EDIT_OWN], incident)"
            >
              <font-awesome-icon icon="pen"/>
            </span>
            {{ $t('processes.create.description_label') }}
          </h5>
          <h5 class="h5" v-if="showOnTask">
            <span class="float-right" v-if="showDescriptionInput">
              <div class="text-right">
                <b-button class="btn-sm inline-edit-button"
                          variant="secondary"
                          @click="cancelDescriptionForm"
                          qid="process-description-cancel-button"
                >
                  {{ $t('processes.legal_basis.create.cancel') }}
                </b-button>
                <b-button class="ml-3 mr-0 btn-sm inline-edit-button"
                          variant="success"
                          @click="formDescriptionSubmit"
                          qid="incident-description-submit-button"
                          v-if="isGranted([permissions.INCIDENT_CATEGORY_EDIT, permissions.INCIDENT_CATEGORY_EDIT_OWN], incident)"
                >
                  {{ $t('processes.legal_basis.create.submit') }}
                </b-button>
              </div>
            </span>
            <span class="float-right btn-sm btn-edit mr-0"
                  @click="showDescriptionInputFunction"
                  qid="edit-incident-description"
                  v-if="!showDescriptionInput && isGranted([permissions.INCIDENT_CATEGORY_EDIT, permissions.INCIDENT_CATEGORY_EDIT_OWN], incident)"
            >
              <font-awesome-icon icon="pen"/>
            </span>
            &nbsp;
          </h5>
          <span v-if="!showOnTask">
            <span class="cursor-pointer task-label-open mr-2 ml-2 mr-2"
                  v-if="getTask('update_description')"
            >
              <UpdateSingleTaskModal
                  :task="myTasks[0]"
                  @reloadContent="reloadContent"
                  :editIcon="true"
                  name="123"
              ></UpdateSingleTaskModal>
            </span>
            <span v-if="getGuide('update_description')">
              <GuideButton :guide="getGuide('update_description')"></GuideButton>
            </span>
          </span>
        </div>
        <div v-if="showDescriptionInput">
          <b-form-textarea
            qid="edit-p-form-description"
            v-model="incidentEditDescription"
            rows="6"
            :placeholder="$t('maintenance.third_parties.create.description_placeholder')"
          ></b-form-textarea>
        </div>
        <div v-if="!showDescriptionInput" class="section-container">
          <div v-if="incident.description && incident.description.length > descriptionLength">
            <p v-if="showFullDescription" class="text-formatted">{{ incident.description }}</p>
            <p v-if="!showFullDescription" class="text-formatted">{{ incident.description | truncate(descriptionLength) }}</p>
            <div class="text-center mt-3" @click="showFullDescription=!showFullDescription">
              <span class="cursor-pointer" v-if="!showFullDescription">
                <span class="mr-2">
                  {{ $t('system.view_more') }}
                </span>
                <font-awesome-icon icon="chevron-down"/>
              </span>
              <span class="cursor-pointer" v-if="showFullDescription">
                <span class="mr-2">
                  {{ $t('system.view_less') }}
                </span>
                <font-awesome-icon icon="chevron-up"/>
              </span>
            </div>
          </div>
          <p v-if="incident.description && incident.description.length <= descriptionLength"
             class="text-formatted"
          >{{ incident.description }}</p>
          <p v-if="!incident.description" class="text-muted">
            {{ $t('system.missing_input') }}
          </p>
        </div>
        <br>
        <span class="text-muted">
          {{ $t('maintenance.incidents.incident_categories.description_tip') }}
        </span>
      </div>
    </div>

  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';
  import {config} from '@/config.js'
  import UpdateSingleTaskModal from '@/views/Tasks/UpdateSingleTaskModal.vue';
  import GuideButton from '@/components/guide/GuideButton.vue';


  export default {
    name: 'DescriptionBlock',
    data: function() {
      return {
        incident: {},
        descriptionLength: config.descriptionLength,
        showFullDescription: false,
        showDescriptionInput: false,
        showPurposeInput: false,
        incidentEditDescription: '',

        error: '',
        myGuides: [],
        myTasks: []
      }
    },
    props: {
      object: {
        type: Object,
        required: true
      },
      showOnTask: {},
      submitForm: {},
      task: {}
    },
    components: {
      Avatar,
      UpdateSingleTaskModal,
      GuideButton
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getReloadContent() {
        return this.$store.state.updateContent
      },
      getReloadTasks() {
        return this.$store.state.reloadTasks
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getReloadContent: function () {
        if (!this.showOnTask) {
          if (this.$store.state.updatedObject && this.$store.state.updatedObject.id) {
            if (this.$store.state.updatedObject.id == this.incident.id && this.$store.state.updatedObject.who_am_i == this.incident.who_am_i) {
              this.incident = this.$store.state.updatedObject
            }
          }
          this.loadContent()
        }
      },
      getReloadTasks: function () {
        if (!this.showOnTask) {
          this.loadTasks('update_description')
        }
      },
      object: function (value) {
        this.incident = value

        if (this.showOnTask && !this.incident.description) {
          this.incidentEditDescription = ''
          this.showDescriptionInput = true;
        }

        if (this.showOnTask && this.incident.description) {
          this.showDescriptionInput = false;
        }

        this.loadTasks('update_description');
      },
      submitForm: function (value) {
        if (value) {
          if (this.showDescriptionInput) {
            this.formDescriptionSubmit()
          }
        }
      }
    },
    methods: {
      getTask(code) {
        let existingTask = _.find(this.myTasks, function(object) {
          return object.code == code
        });
        return existingTask
      },
      reloadContent() {
        this.loadContent()
        this.loadTasks('update_description');
      },
      loadTasks(code) {
        let self = this;
        if (this.getClient.projectModule) {
          piincHttp.get('projects/me/tasks', { params:
            {
              per_page: 1,
              status: 'pending',
              model_type: this.incident.who_am_i,
              model_id: this.incident.id,
              code: code,
              client: this.getClient.slug
            }
          }).then(function(response) {
            self.myTasks = []
            if (response.data.items.length) {
              self.myTasks.push(response.data.items[0])
            }
          }, function() {});
        }
      },
      navigateToTask(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
        this.$router.push({ name: 'incident_categories.view', params: { slug: object.model.slug }, query: { task: object.id }})
      },
      openToolbar(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'Incident' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: language,
            type: 'Incident',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      },
      showDescriptionInputFunction() {
        this.showDescriptionInput = true;
        this.incidentEditDescription = this.incident.description;
      },
      formDescriptionSubmit() {
        let self = this;
        piincHttp.put('incident-categories/' + this.incident.slug, {
          description: this.incidentEditDescription
        }).then(function(response) {
          self.incident = response.data;
          self.showDescriptionInput = false;
          self.$store.commit('storeUpdateContent', self.incident);
          self.loadTasks('update_description');
          self.$toastr('success', self.$t('maintenance.incidents.incident_categories.update.success'))
        }, function(error) {
          if (error.status !== 200) {
            self.error = error.data.message;
          }
        })
      },
      cancelDescriptionForm() {
        this.showDescriptionInput = false;
        this.incidentEditDescription = this.incident.description;
      },
      loadContent() {
        let self = this;
        piincHttp.get('incident-categories/' + this.incident.slug, { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.incident = response.data;
        }, function() {});
      }
    },
    created () {
      this.incident = this.object;

      if (this.showOnTask && !this.incident.description) {
        this.showDescriptionInput = true;
      }

      if (this.showOnTask) {
        this.loadContent()
      }

      if (this.incident && this.incident.id) {
        this.loadTasks('update_description');
      }

      this.loadGuides('update_description');

    }
  }
</script>
